import { DateTime } from 'luxon';
import { Carriers } from 'smg/customer-api/carriers';
import * as models from 'smg/customer-api/models';
import { Shipments } from 'smg/customer-api/shipments';
import * as template from 'smg/template';
import { PageLoader } from '../account';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    const carriersMap = await Carriers();

    const pl: PageLoader<models.Shipment> = new PageLoader<models.Shipment>({
        get: () => Shipments({
            sort: pl.sort(),
            max: pl.currentPageSize(),
            data: 'order, created, trackingNumber, carrierId, shippedAt, deliveredAt',
            p: pl.currentPage(),
            q: pl.search(),
        }).then(data => ({ rows: data.results, nextPage: data.nextPage })),
        draw: shipment => {
            const shipmentEl = template.Clone('#trackingInformation').firstElementChild as HTMLElement;

            // Place order/invoice numbers and adding appending the order link
            const orderNumberField = shipmentEl.querySelector('.order-number') as HTMLElement;
            const orderNumberLink = shipmentEl.querySelector('.order-link') as HTMLAnchorElement;
            const order = shipment.order;
            if (!order) {
                throw new Error(`shipment ${shipment.id} missing order`);
            }
            orderNumberField.textContent = String(order.invoiceNumber);
            orderNumberLink.href += String(order.invoiceNumber);

            // Place order date. shipment.created
            const orderDate = shipmentEl.querySelector('.order-date') as HTMLElement;
            if (shipment.created.isValid) {
                orderDate.textContent = shipment.created.toLocaleString(DateTime.DATE_SHORT);
            }

            // Place tracking number
            const trackingNumberField = shipmentEl.querySelector('.shipment-tracking-number') as HTMLElement;
            trackingNumberField.textContent = shipment.trackingNumber;

            // Place the ship carrier
            const carrierFields = shipmentEl.querySelector('.shipment-carrier') as HTMLElement;
            if (shipment.carrierID) {
                carrierFields.textContent = carriersMap.get(shipment.carrierID)?.name || '';
            }

            // Place status field
            const statusField = shipmentEl.querySelector('.shipment-status') as HTMLElement;
            if (shipment.deliveredAt.isValid) {
                statusField.textContent = `Delivered ${shipment.deliveredAt.toLocaleString(DateTime.DATE_SHORT)}`;
            } else if (shipment.shippedAt.isValid) {
                statusField.textContent = `Shipped ${shipment.shippedAt.toLocaleString(DateTime.DATE_SHORT)}`;
            } else {
                statusField.parentElement?.parentElement?.remove();
            }

            // Place the href with appended link w/ tracking number. First determine the carrier link
            const trackingLinksField = shipmentEl.querySelector('.tracking-link') as HTMLAnchorElement;
            const carrier = carriersMap.get(shipment.carrierID);
            trackingLinksField.href = carrier?.trackingURL(shipment.trackingNumber) || '';

            return shipmentEl;
        },

    });

    pl.load();
}
